/** The down payment and the balloon payment together have to leave a financed amount. */
export function isValidBalloonCombination(downPayment: number, balloonPayment: number | null) {
  return balloonPayment === null || downPayment + balloonPayment < 100;
}
